exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".chartLabelValue-b7e92{fill:#262626;font-size:16px;font-weight:600}.chartLabelPeriod-fd54e{fill:#262626;font-size:14px;font-weight:400}", ""]);

// Exports
exports.locals = {
	"chartLabelValue": "chartLabelValue-b7e92",
	"chartLabelPeriod": "chartLabelPeriod-fd54e"
};